<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<ion-item *ngIf="urls?.length > 0" class="image-container" lines="none">
	<swiper [pagination]="true" [navigation]="true">
		<ng-template swiperSlide *ngFor="let url of urls">
			<img [src]="url + '&preset=report'" alt="" (click)="open(url)" />
		</ng-template>
	</swiper>
</ion-item>
